import React from 'react';
import { withRouter } from 'react-router';
import BullishAccount from './bullish-account/bullish-account';
import bullishContext from '../../stores/bullish-store';

const BullishGroup = () => {
  const bullish = React.useContext(bullishContext);

  React.useEffect(() => {
    bullish.fetch();
  }, [bullish]);

  return (
    <div data-testid="bullish">
      <BullishAccount source={bullish} />
    </div>
  );
};

export default withRouter(BullishGroup);
